import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		name: Yup.string()
			.required(t("fill_required_fields"))
			.min(2, t("name_has_to_be_at_least_two_characters_long")),
	});
};
